export default __webpack_public_path__ + "static/media/LHDeng.12ab2e50.pdf";